<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.roleMenuManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>
              {{ $t("management.roleId") }}
            </th>
            <td>
              {{ role.roleId }}
            </td>
            <th>{{ $t("management.roleName") }}</th>
            <td>
              {{ role.roleName }}
            </td>
            <th>{{ $t("common.description") }}</th>
            <td>{{ role.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="brick_box">
      <!--------------------------------  메뉴 변경 저장 --------------------------------------------------------->
      <div class="p-2" style="text-align: right">
        <router-link to="/management/role" class="btn btn-outline-dark btn-md m-1">{{
          $t("common.list")
        }}</router-link>
        <button type="button" @click="roleMenuMgmt" class="btn btn-primary btn-md m-1">
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="saveRoleMenu" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
        <button type="button" @click="deleteRole" class="btn btn-secondary btn-md m-1">
          {{ $t("common.delete") }}
        </button>
      </div>

      <!-----------------------------------  메뉴  -------------------------------------------------->
      <div style="overflow: auto; height: 450px">
        <table class="list_tbl" style="text-align: left">
          <thead>
            <tr>
              <th class="mobile_h">
                <input
                  type="checkbox"
                  @click="goCheckAll($event.target.checked)"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_row">{{ $t("management.menu") }}</th>
              <th class="mobile_row">{{ $t("management.url") }}</th>
            </tr>
          </thead>
          <tbody v-if="roleMenuList.length > 0">
            <tr v-for="(menu, index) in roleMenuList" :key="index">
              <td>
                <input type="checkbox" v-model="menu.selected" />
              </td>
              <td :id="menu.label">{{ menu.label }}</td>
              <td>{{ menu.menuUrl }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="3">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!---------------------------------메뉴 추가------------------------------------------->
    <MenuModal id="menuModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.menuSetting") }}</h3>
      </template>
      <template slot="body">
        <div class="bg-white p-3 m-3" style="overflow: auto; height: 400px">
          <a-tree
            :replaceFields="replaceFields"
            :treeData="treeData"
            v-model="checkedKeys"
            :checkable="true"
            defaultExpandAll
            @check="onCheck"
          />
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </MenuModal>
  </section>
</template>

<script>
import { getRole } from "@/api/role";
import {
  getRoleMenuList,
  getMgmtMenuList,
  deleteUserRoleMenuList,
  saveUserRoleMenu,
} from "@/api/menu";
import MenuModal from "@/components/modal/MenuModal";
export default {
  components: {
    MenuModal,
  },
  data() {
    return {
      role: "",
      roleId: "",
      confirmYN: false,
      checkAll: false,
      roleMenuList: [],
      parentMenu: [],
      childMenu: [],
      thridMenu: [],
      allMenuList: [],
      allParentMenu: [],
      allChildMenu: [],
      deleteList: [],
      children: [],
      parent: [],
      items: [],
      treeData: [],
      replaceFields: {
        title: "name",
        key: "id",
        Pid: "pid",
      },
      checkedKeys: [],
      showModal: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.roleId = this.$route.params.roleId;
        const { data } = await getRole(this.roleId);
        // 사용자 정보
        this.role = data.role;
        const response = await getRoleMenuList(this.role);
        this.parentMenu = response.data.parentMenu;
        this.childMenu = response.data.childMenu;
        this.roleMenuList = response.data.roleMenuList;
        if (this.roleMenuList == null) {
          this.roleMenuList = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    //사용자 메뉴 관리 팝업
    async roleMenuMgmt() {
      try {
        const { data } = await getMgmtMenuList("1");
        this.list = data.allMenuList;
        this.parent = data.parentMenu;
        this.children = data.childMenu;
        this.thridMenu = data.thridMenu;

        this.items = data.parentMenu;
        for (let i in this.parent) {
          this.items[i].children = [];
          for (let j in this.children) {
            if (this.parent[i].id == this.children[j].pid) {
              let node = this.children[j];
              node.children = [];
              for (let a in this.thridMenu) {
                if (this.children[j].id == this.thridMenu[a].pid) {
                  node.children.push(this.thridMenu[a]);
                }
              }

              this.items[i].children.push(node);
            }
          }
        }

        this.treeData = this.items;
        this.showModal = true;
      } catch (error) {
        console.log(error);
      }
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    // 선택한 메뉴 기존 리스트에 추가
    getSelected() {
      for (let j in this.list) {
        for (let i in this.checkedKeys) {
          if (this.list[j].id == this.checkedKeys[i]) {
            // 중복 체크
            for (let a in this.roleMenuList) {
              if (this.list[j].id == this.roleMenuList[a].menuId) {
                alert(this.$t("alert.alreadyExist"));
                return;
              }
            }
            this.list[j].crudType = "I";
            this.list[j].roleId = this.roleId;
            this.list[j].menuId = this.checkedKeys[i];
            this.list[j].label = this.list[j].name;
            this.roleMenuList.push(this.list[j]);
          }
        }
      }
      this.showModal = false;
    },
    // 체크한 menu 삭제
    async deleteRole() {
      for (let i in this.roleMenuList) {
        if (this.roleMenuList[i].selected) {
          this.deleteList.push(this.roleMenuList[i]);
        }
      }
      if (this.deleteList.length > 0) {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          try {
            const { data } = await deleteUserRoleMenuList(this.deleteList);
            if (data.status) {
              alert(this.$t("alert.deletedSuccessfully"));
              this.deleteList = [];
              this.checkAll = false;
              this.fetchData();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.deleteList = [];
          return;
        }
      }
    },
    // 메뉴 변경 사항 저장
    async saveRoleMenu() {
      try {
        const { data } = await saveUserRoleMenu(this.roleMenuList);
        if (data.status) {
          alert(this.$t("alert.changedSuccessfully"));
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.showModal = false;
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.roleMenuList) {
        this.roleMenuList[i].selected = this.checkAll;
      }
    },
    // role 검색
    searchBtn() {
      this.getUserRole();
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.getUserRole();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.list_tbl {
  text-align: left !important;
}
table tbody tr td {
  text-align: left !important;
}
</style>
